



























































import DataTableInstallmentsSimple from '@/app/shared/components/data-tables/installments-simple.vue';
import { InstallmentModel, InteractionModel } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { DataTableInstallmentsSimple } })
export default class DialogGenerateAttemptComponent extends Vue {
  @Prop(Array) readonly data!: InstallmentModel[];

  private installmentList: InstallmentModel[] = [];
  private loading = false;
  private dialog = false;
  private valueTab = '';

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }

  private verifyInstallmentDate(installments: InstallmentModel[]) {
    let result = true;
    for (const installment of installments) {
      if (this.refs._.isEmpty(installment.OriginalDueDate)) {
        result = false;
        break;
      }
      if (
        this.refs
          .moment(installment.OriginalDueDate, 'YYYY/MM/DD')
          .format('YYYY/MM/DD') <
        this.refs.moment(new Date(), 'YYYY/MM/DD').format('YYYY/MM/DD')
      ) {
        result = false;
        break;
      }
    }
    return result;
  }

  private async generateAttempt() {
    if (!this.verifyInstallmentDate(this.data)) {
      this.$toast(this.$t('toasts.invalid_due_date'));
      return;
    }
    if (!this.valueTab) {
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    this.loading = true;
    const promisesAttempts: Promise<void>[] = [];
    const promisesInstallment: Promise<void>[] = [];

    this.data.map(async (installment) => {
      if (
        this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Canceled.toString() ||
        this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.PaidByOtherWay.toString() ||
        this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Accredit.toString()
      ) {
        promisesInstallment.push(
          this.refs.modules.contract.updateInstallment({
            contractId: this.refs.modules.contract.contract.Id,
            installmentId: installment.Id,
            installment,
            descReason: this.valueTab,
          })
        );

        if (
          this.refs.enums.InstallmentStatus[installment.Status] !=
          this.refs.enums.InstallmentStatus.Canceled.toString()
        ) {
          promisesInstallment.push(
            this.refs.modules.contract.defaulterInstallment({
              contractId: this.refs.modules.contract.contract.Id,
              installmentId: installment.Id,
              descReason: this.valueTab,
            })
          );
        }
      }
      promisesAttempts.push(
        this.refs.modules.contract.createAttempt({
          contractId: this.refs.modules.contract.contract.Id,
          installment,
        })
      );
    });
    Promise.all(promisesInstallment).then(async () => {
      Promise.all(promisesAttempts)
        .then(async () => {
          this.refs.modules.ticket.SET_EDIT_INSTALLMENT_GENERATE(true);
          this.refs.modules.ticket
            .createInteraction(
              new InteractionModel(
                this.$t('action_code.ac14'),
                this.$t('action_desc.ad37') +
                  (this.valueTab ? ' (' + this.valueTab + ')' : '')
              )
            )
            .then(() => {
              localStorage.removeItem('tabulacao');
              this.$bus.$emit('cleanValueTab');
            });
          await this.refs.modules.contract.loadInstallmentList(
            this.$route.params.id
          );
          this.$toast(this.$t('toasts.generate_attempt_successfully'));
          this.dialog = false;
          this.$emit('uncheckInstallmentList');
        })
        .catch((err) => {
          this.$toast.error('ERROR ? ', err);
          this.$toast.error(this.$t('toasts.generate_attempt_error'));
        })
        .finally(() => (this.loading = false));
    });
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value) {
      const installmentLast = this.refs._.maxBy(
        this.refs.modules.contract.installmentList,
        'Number'
      );
      this.installmentList = this.refs._.map(this.data, (installment) => {
        return {
          Id: this.refs.util.generateGuid(),
          Status: this.refs.enums.InstallmentStatus.Generated,
          OriginalDueDate: this.refs.moment().format('YYYY-MM-DD'),
          Reference: {
            Year:
              installmentLast?.Reference?.Year ||
              installmentLast?.YearReference,
            Month:
              (installmentLast?.Reference?.Month ||
                installmentLast?.MonthReference ||
                0) + 1,
          },
          Value: installmentLast?.Value,
          OurCode: installment.OurCode,
          Number: installmentLast?.Number ? installmentLast.Number + 1 : 0,
          InstallmentType: installment.InstallmentType,
        };
      });
    }
  }
}
